import { AppBar, Box, CardMedia, IconButton, Menu, MenuItem, useTheme } from "@mui/material";
import { useState } from "react";
import { ProfileIcon } from "../customSVGs";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../redux-store/reducers";
import { logout } from "../../redux-store/actions/auth";
import { LOGOUT_SUCCESS } from "../../redux-store/types/auth";

export default function InvOnboardingLayout({ children }: { children: JSX.Element }): JSX.Element {
    const { palette } = useTheme()
    const history = useHistory()
    const dispatch = useDispatch()

    const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
    const menuOpen = Boolean(menuAnchorEl);

    const { token = null } = useSelector((store: RootStateType) => store.auth);

    const handleProfileLogout = () => {
        if (token) {
            dispatch(logout());
        }

        dispatch({ type: LOGOUT_SUCCESS })
        history.push('/login');
    }
    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    overflowX: 'auto'
                }}
            >
                <AppBar
                    position="static"
                    elevation={0}
                    sx={{
                        bgcolor: 'common.white',
                        padding: "0px 20px"
                    }}
                >
                    <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <Box>
                            <CardMedia
                                component="img"
                                // src="/images/kfintechHeaderImg.svg"
                                onClick={() => history.push('/')}
                                src="/images/abcl-wealth-logo.svg"
                                alt="Logo"
                                // sx={{ width: '160px', m: 3, mt: 2 }}
                                sx={{
                                    // width: '15rem',
                                    width: '12rem',
                                    // margin: "20px 0px 20px 10px",
                                    margin: "15px 0px 0px 10px",
                                    cursor: 'pointer',
                                }}
                            />
                        </Box>
                        <Box sx={{
                            display: { xs: 'flex' },
                            alignItems: 'center',
                        }}>
                            <IconButton
                                sx={{ padding: 0, ml: 1.5 }}
                                onClick={(e) => setMenuAnchorEl(e.currentTarget)}
                            >
                                <ProfileIcon />
                            </IconButton>

                        </Box>
                    </Box>
                </AppBar>
                <Box
                    component="main"
                    sx={{ padding: "30px 20px 20px 20px" }}
                >
                    {children}
                </Box>
            </Box>
            <Menu
                anchorEl={menuAnchorEl}
                open={menuOpen}
                onClose={() => setMenuAnchorEl(null)}
                MenuListProps={{
                    'aria-labelledby': 'logout-button',
                    sx: {
                        padding: "8px 0px",
                    }
                }}
                slotProps={{
                    paper: {
                        style: {
                            width: '200px',
                            borderRadius: "12px",
                            backgroundColor: palette.common.white,
                        }
                    }
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}

            >
                <MenuItem
                    onClick={() => {
                        handleProfileLogout()
                    }}
                >
                    Logout
                </MenuItem>
            </Menu >
        </>
    )
}
